import type { AxiosInstance } from 'axios';
import { GovError } from '@gov-nx/core/app';
import type { Nullable } from '@gov-nx/core/types';
import type { AgendyAisAisDto } from '../generated';

export const aisQuery = async (
	axiosInstance: AxiosInstance,
	code: Nullable<string>
): Promise<AgendyAisAisDto> => {
	if (!code) throw new GovError('Code is required parameter');

	const { data } = await axiosInstance.get(`/api/v1/ais/${code}`);
	return data;
};
